import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom/dist";
import Table from "../../../../../core/pagination/datatable";

import { Edit } from "feather-icons-react/build/IconComponents";
import EditManualAttendance from "./Edit";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_EMPLOYEES_LIST,
} from "../../RollCallConfig/RollCallConfig";
import { Select, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CommonFooter from "../../../../../core/common/footer/commonFooter";

const RollcallManualAttendanceList = () => {
  const today = new Date().toISOString().split("T")[0];
  const [employees, setEmployees] = useState([]);
  const [editObj, setEditObj] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedstartDate, setSelectedstartDate] = useState(today);
  const [selectedendDate, setSelectedendDate] = useState(today);
  const [teamAttendance, setTeamAttendance] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    const isManager = sessionStorage.getItem("isManager");

    if (isManager === "false") {
      alert("You don't have access to this page.");
      sessionStorage.clear();
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMPLOYEES_LIST}?superid=${superIdData}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setEmployees(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setEmployees([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [superIdData, tokenData]);

  const empOptions = employees.map((emp) => ({
    value: emp.RegId,
    label: emp.UserName,
  }));

  useEffect(() => {
    const handleSubmit = async () => {
      setloading(true);
      if (tokenData && superIdData) {
        try {
          const params = new URLSearchParams();
          params.append("Superid", superIdData);
          if (selectedstartDate) params.append("startdate", selectedstartDate);
          if (selectedendDate) params.append("enddate", selectedendDate);
          if (selectedEmp) params.append("regid", selectedEmp);

          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/Attendance/getattendanceForAdmin?${params.toString()}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (response.ok) {
            const data = await response.json();
            if (data.status) {
              console.log("team att:", data);
              setTeamAttendance(data["ResultData"]);
            } else {
              setTeamAttendance([]);
            }
          } else {
            throw new Error("Failed to fetch data");
          }
        } catch (error) {
          console.error("Error:", error);
        } finally {
          setloading(false);
        }
      }
    };
    handleSubmit();
  }, [superIdData, tokenData]);

  const handleSubmit = async () => {
    setloading(true);
    if (tokenData && superIdData) {
      try {
        const params = new URLSearchParams();
        params.append("Superid", superIdData);
        if (selectedstartDate) params.append("startdate", selectedstartDate);
        if (selectedendDate) params.append("enddate", selectedendDate);
        if (selectedEmp) params.append("regid", selectedEmp);

        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/Attendance/getattendanceForAdmin?${params.toString()}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        if (response.ok) {
          const data = await response.json();
          if (data.status) {
            console.log("team att:", data);
            setTeamAttendance(data["ResultData"]);
          } else {
            setTeamAttendance([]);
          }
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setloading(false);
      }
    }
  };

  const filteredData = teamAttendance.filter(
    (item) => item && item.UserName && item.UserName.toLowerCase(),
  );
  console.log(teamAttendance);
  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      sorter: (a, b) => a.sno - b.sno,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName.localeCompare(b.UserName),
      render: (text) => (
        <span>{text.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
      ),
    },
    {
      title: "Actual Shift",
      dataIndex: "ActualShiftName",
      sorter: (a, b) => {
        const nameA = a.ActualShiftName || "";
        const nameB = b.ActualShiftName || "";
        return nameA.localeCompare(nameB);
      },
    },
    {
      title: "Entry Time",
      dataIndex: "DtInTime",
      render: (text) => {
        const time = text?.split("T")[1]?.substring(0, 5);
        return time || "";
      },
    },
    {
      title: "Exit Time",
      dataIndex: "DtOutTime",
      render: (text) => {
        const time = text?.split("T")[1]?.substring(0, 5);
        return time || "";
      },
    },
    {
      title: "Entry Status",
      dataIndex: "InStatus",
      sorter: (a, b) => a.InStatus.localeCompare(b.InStatus),
    },
    {
      title: "Exit Status",
      dataIndex: "OutStatus",
      sorter: (a, b) => a.OutStatus.localeCompare(b.OutStatus),
    },
    {
      title: "Action",
      dataIndex: "exitStatus",
      // sorter: (a, b) => a.exitStatus.localeCompare(b.exitStatus),
      render: (_, record) => (
        <Link
          to=""
          className="dropdown-item"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRightEditMA"
          aria-controls="offcanvasRightEditMA"
          onClick={() => setEditObj(record)}
        >
          <Edit className="info-img text-info" />
        </Link>
      ),
    },
  ];

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Manual Attendance
                    </h4>
                  </ol>
                </nav>
                <h6>Update Attendance By Employee</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={() => window.location.reload()}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
  
  {/* Left Side (empty like above) */}
  <div className="search-set col-lg-auto col-md-12 mb-md-1 mb-sm-1 mb-lg-0"></div>

  {/* Right Side Filters */}
  <div className="col-lg-auto col-md-12 mt-md-4 mt-sm-4 mt-lg-0">
    <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">

      {/* Employee */}
      <div className="me-2">
        <Select
          showSearch
          placeholder="Choose Employee"
          value={selectedEmp}
          onChange={setSelectedEmp}
          allowClear
          options={empOptions}
          style={{ width: 190 }}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />
      </div>

      {/* Start Date */}
      <div className="me-2">
        <input
          type="date"
          className="form-control"
          value={selectedstartDate}
          onChange={(e) => setSelectedstartDate(e.target.value)}
          style={{ width: 160 }}
        />
      </div>

      {/* End Date */}
      <div className="me-2">
        <input
          type="date"
          className="form-control"
          value={selectedendDate}
          onChange={(e) => setSelectedendDate(e.target.value)}
          style={{ width: 160 }}
        />
      </div>

      {/* Search Button */}
      <div className="me-2">
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          style={{ height: 37 }}
        >
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </button>
      </div>

    </div>
  </div>
</div>

            <div className="card-body">
              <div className="table-responsive brand-table">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : filteredData.length > 0 ? (
                  <Table columns={columns} dataSource={filteredData} />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />

        <EditManualAttendance editObj={editObj} />
      </div>
    </div>
  );
};

export default RollcallManualAttendanceList;
